var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTableRow",
    {
      staticClass: "activities-listing-table__row",
      attrs: {
        isSpotlight: _vm.isActivitySelected,
        checkbox: {
          value: _vm.activity.type + "_" + _vm.activity.activityId,
          dataBot: "activities-listing-checkbox__" + _vm.activity.activityId
        }
      }
    },
    [
      _vm._l(_vm.columns, function(column) {
        return [
          column.code === "due_date"
            ? _c(
                "CompassTableBodyCell",
                { key: column.code, class: _vm.dateContainerClasses },
                [
                  _vm.activityIsLate
                    ? _c("BadgeActivityStatus", {
                        attrs: {
                          tag: _vm.tag(_vm.activity.type, _vm.activity.isLate)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: _vm.isBoldDateLabel(
                        _vm.activity.type,
                        _vm.activity.isLate
                      )
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("dateFormatter")(
                              _vm.activity.date,
                              "SLASHED_DATE_TIME"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "type"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: { minWidth: "92px", maxWidth: "92px" }
                },
                [
                  _c("CompassObject", {
                    attrs: {
                      size: _vm.sizeObjectType,
                      object: _vm.objectType(_vm.activity.type)
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "priority"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: { minWidth: "108px", maxWidth: "108px" }
                },
                [
                  _c("ActivitiesPriorityIconButton", {
                    attrs: {
                      isPending: _vm.activity.prioritisation.pending,
                      isActive: _vm.activity.prioritisation.priority > 0,
                      size: _vm.sizePriorityButton,
                      enabled: _vm.activity.acl.can_be_updated,
                      dataBot: "activities-listing__priority-icon-button"
                    },
                    on: { clicked: _vm.handlePriority }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "label"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "label__container",
                  attrs: { minWidth: "160px", maxWidth: "160px" }
                },
                [
                  _vm.activity.label && _vm.activity.label.label
                    ? _c(
                        "CompassTag",
                        {
                          attrs: {
                            type: "dot",
                            color: "custom",
                            size: _vm.sizeLabelTag,
                            customColor: _vm.getLabelColor(_vm.activity.label)
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.activity.label.label) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "related"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "related__container",
                  class: _vm.classesRelatedContainer,
                  attrs: { minWidth: "320px", maxWidth: "580px" }
                },
                _vm._l(_vm.activity.related, function(related) {
                  return _c("ActivitiesListingRelatedItem", {
                    key: related.type + "_" + related.id,
                    attrs: { data: related, isActivityPage: _vm.isActivityPage }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "description"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "description__container",
                  attrs: { minWidth: "480px", maxWidth: "720px" }
                },
                [
                  _vm.activity.description
                    ? _c("div", {
                        staticClass: "typographies-paragraph-medium-regular",
                        domProps: {
                          innerHTML: _vm._s(_vm.activity.description)
                        }
                      })
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "title"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  staticClass: "title__container",
                  attrs: { minWidth: "220px", maxWidth: "220px" }
                },
                [
                  _vm.activity.title
                    ? _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.activity.title) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          column.code === "staff"
            ? _c(
                "CompassTableBodyCell",
                {
                  key: column.code,
                  attrs: { minWidth: "140px", maxWidth: "168px" }
                },
                [
                  _c("CompassMultiAvatar", {
                    attrs: { avatars: _vm.formattedStaff }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      }),
      _vm._v(" "),
      _c(
        "CompassTableBodyCell",
        {
          ref: "cell-actions",
          staticClass: "activities-listing__cell-actions",
          attrs: {
            maxWidth: _vm.widthActionsCol + "px",
            minWidth: _vm.minWidthActionsCol + "px",
            fixed: "right"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
            },
            mouseenter: function($event) {
              _vm.isActivityPage ? _vm.onEnterActionsCell() : null
            },
            mouseleave: function($event) {
              _vm.isActivityPage ? _vm.onLeaveActionsCell() : null
            }
          }
        },
        [
          _c("ActivitiesListingActions", {
            ref: "wrapper-icon-buttons",
            staticClass: "actions__container",
            attrs: {
              activity: _vm.activity,
              isActivityPage: _vm.isActivityPage
            },
            on: {
              updateStatus: function($event) {
                return _vm.$emit("updateStatus", { activity: _vm.activity })
              },
              close: function(data) {
                _vm.$emit("onPanelClosed", data)
              },
              updateDueDate: function(data) {
                _vm.$emit("updateDueDate", data)
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }